import { createSlice } from '@reduxjs/toolkit'

import {
    createObjectFromKeysAndValue,
    createHash,
    calculateKPI,
    calculateGoalkeeperKPI,
    calculateRank
} from "../helpers";
import {FIELD_PLAYER_EVENTS, GOALKEEPER_EVENTS, PLAYER_TYPES} from "../constants";
import {matchSliceAction} from "./matchSlice";

const initialState = {
    players: []
};

//For test
// for(let i = 0; i < 14; i++) {
//     initialState.players.push({
//         name: '',
//         type: 'FIELD_PLAYER',
//         inGameNumber: 11,
//         id: createHash(),
//         inGame: false,
//         inGameTime: 0,
//         startAfterMatchPause: false,
//         rank: 0,
//         kpi: 0,
//         events: createObjectFromKeysAndValue(FIELD_PLAYER_EVENTS, 0)
//     })
// }

export const playerSlice = createSlice({
    name: 'player',
    initialState,
    reducers: {
        addPlayer: (state, {payload: {name = '', type, inGameNumber}}) => {
            const events = type === PLAYER_TYPES[0] ? FIELD_PLAYER_EVENTS : GOALKEEPER_EVENTS;
            state.players.push({
                name,
                type,
                inGameNumber,
                id: createHash(),
                inGame: false,
                inGameTime: 0,
                startAfterMatchPause: false,
                rank: 0,
                kpi: 0,
                events: createObjectFromKeysAndValue(events, 0)
            })
        },
        removePlayer: (state, {payload: {id}}) => {
            state.players = [...state.players.filter(player => player.id !== id)]
        },
        updateTime: (state, {payload: {time, id}}) => {
            const findPlayerIndex = state.players.findIndex(player => player.id === id)
            const {type, events} = state.players[findPlayerIndex];
            state.players[findPlayerIndex].inGameTime += time;
            if(type === PLAYER_TYPES[0]) {
                state.players[findPlayerIndex].kpi = calculateKPI(events, state.players[findPlayerIndex].inGameTime/1000)
            } else {
                state.players[findPlayerIndex].kpi = calculateGoalkeeperKPI(events, state.players[findPlayerIndex].inGameTime/1000)
            }
            state.players.forEach(player => {
                player.rank = calculateRank(state.players, player.id)
            })
        },
        startGame: (state, {payload: {id}}) => {
            const findPlayerIndex = state.players.findIndex(player => player.id === id)
            state.players[findPlayerIndex].inGame = true;
            state.players[findPlayerIndex].startAfterMatchPause = true
        },
        stopGame: (state, {payload: {id}}) => {
            const findPlayerIndex = state.players.findIndex(player => player.id === id)
            state.players[findPlayerIndex].inGame = false;
            state.players[findPlayerIndex].startAfterMatchPause = false
        },
        incrementEvent: (state, {payload: {id, eventName}}) => {
            const findPlayerIndex = state.players.findIndex(player => player.id === id)
            state.players[findPlayerIndex].events[eventName] += 1
            const {type, events} = state.players[findPlayerIndex];
            if(type === PLAYER_TYPES[0]) {
                state.players[findPlayerIndex].kpi = calculateKPI(events, state.players[findPlayerIndex].inGameTime/1000)
            } else {
                state.players[findPlayerIndex].kpi = calculateGoalkeeperKPI(events, state.players[findPlayerIndex].inGameTime/1000)
            }
            state.players.forEach(player => {
                player.rank = calculateRank(state.players, player.id)
            })        },
        decrementEvent: (state, {payload: {id, eventName}}) => {
            const findPlayerIndex = state.players.findIndex(player => player.id === id)
            state.players[findPlayerIndex].events[eventName] -= 1
            const {type, events} = state.players[findPlayerIndex];
            if(type === PLAYER_TYPES[0]) {
                state.players[findPlayerIndex].kpi = calculateKPI(events, state.players[findPlayerIndex].inGameTime/1000)
            } else {
                state.players[findPlayerIndex].kpi = calculateGoalkeeperKPI(events, state.players[findPlayerIndex].inGameTime/1000)
            }
            state.players.forEach((player, i) => {
                player.rank = calculateRank(state.players, player.id)
            })}
    },
    extraReducers: builder => {
        builder
            .addCase(matchSliceAction.setFinish, state => {
                state.players.forEach(player => {
                    player.inGame = false
                })
            })
            .addCase(matchSliceAction.setPause, (state, {payload: {value}}) => {
                if(value) {
                    state.players.forEach(player => {
                        player.inGame = false
                    })
                } else {
                    state.players.forEach(player => {
                        if(player.inGameTime && player.startAfterMatchPause) {
                            player.inGame = true
                        }
                    })
                }
            })
    }
})

export const { actions: playerSliceAction, reducer: playerSliceReducer} =  playerSlice